module.exports = __webpack_public_path__ + "img/image38.77f478ec.webp";